import axios from "../../axios";

const getAllVendors = async () => {
  try {
    const { data } = await axios.get("/portal");
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
};

const linkVendor = async ({ packet }) => {
  try {
    const { data } = await axios.post("/portal", packet);
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
};

export { getAllVendors, linkVendor };